import { useEffect, useState } from 'react';
import { Box, alpha, keyframes, useTheme } from '@mui/material';

const shimmerSweep = keyframes`
  0% { transform: translateX(-120%); }
  100% { transform: translateX(120%); }
`;

const DURACAO_FADE_MS = 400;

interface IShimmerOverlayProps {
  open: boolean;
}

// Cobre o container pai (que deve ter position: relative) com um véu claro e uma
// onda de brilho diagonal passando por cima dos campos — indica "carregando" sem
// bloquear a tela inteira com um overlay escuro, para telas de leitura de dados
// (ex.: abrir um produto existente).
export const ShimmerOverlay: React.FC<IShimmerOverlayProps> = ({ open }) => {
  const theme = useTheme();
  const [montado, setMontado] = useState(open);
  const [entrou, setEntrou] = useState(false);

  useEffect(() => {
    if (open) {
      setMontado(true);
      const raf = requestAnimationFrame(() => setEntrou(true));
      return () => cancelAnimationFrame(raf);
    }

    setEntrou(false);
    const timeout = setTimeout(() => setMontado(false), DURACAO_FADE_MS);
    return () => clearTimeout(timeout);
  }, [open]);

  if (!montado) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: theme.zIndex.fab,
        overflow: 'hidden',
        borderRadius: 'inherit',
        backgroundColor: theme.palette.mode === 'dark'
          ? alpha(theme.palette.background.default, 0.35)
          : alpha('#ffffff', 0.45),
        backdropFilter: 'blur(1.5px)',
        opacity: entrou ? 1 : 0,
        transition: `opacity ${DURACAO_FADE_MS}ms ease`,
        pointerEvents: entrou ? 'auto' : 'none',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '55%',
          height: '100%',
          background: `linear-gradient(100deg, transparent 0%, ${alpha('#ffffff', theme.palette.mode === 'dark' ? 0.16 : 0.75)} 50%, transparent 100%)`,
          animation: `${shimmerSweep} 1.6s ease-in-out infinite`,
        }}
      />
    </Box>
  );
};
